import { render } from "./BankAccountTypeList.vue?vue&type=template&id=08df8154&scoped=true"
import script from "./BankAccountTypeList.vue?vue&type=script&lang=js"
export * from "./BankAccountTypeList.vue?vue&type=script&lang=js"

import "./BankAccountTypeList.vue?vue&type=style&index=0&id=08df8154&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08df8154"]])

export default __exports__